import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { RouteUtils } from "absdk/preliminary/commons/app/router/RouteUtils";
export const UNAUTHORIZED_ROUTE_TEMPLATE = "/absdk/error/unauthorizedRoute/:route";
export const unauthorizedRouteSpec = {
  routeTemplate: UNAUTHORIZED_ROUTE_TEMPLATE,
  routeTitle: props => AbReactResources.unauthorizedRoute_routeTitle(props.route),
  view: {
    modulePath: () => import(/* webpackChunkName: "Builtin_Routes" */"abreact/incubator/ui/app/routes/UnauthorizedRouteView"),
    exportName: "UnauthorizedRouteView"
  },
  routeParamHandler: {
    paramsFromProps: props => ({
      routeParams: {
        route: props.route
      }
    }),
    propsFromParams: params => ({
      route: RouteUtils.getReqParamAsString(params, "route")
    })
  }
};
//# sourceMappingURL=UnauthorizedRouteSpec.js.map
